<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="'绑定站点'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <div class="former">
      <select2
        v-model="form.StationTypeID"
        url="basic?type=StationType"
        placeholder="请选择站点类型"
        no-data-text="无类型"
      ></select2>&nbsp;
      <el-cascader
        v-model="area"
        :options="options"
        :props="props"
        clearable
        placeholder="请选择地区"
        :show-all-levels="true"
        :emitPath="false"
      ></el-cascader>&nbsp;
      <el-button type="primary" @click="onSubmitQuery">
        <i class="fas fa-search"></i>
      </el-button>
    </div>
    <el-table
      :data="itemList"
      v-loading="loading"
      :row-key="getRowKey"
      ref="tb"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="index" :index="pager.size * (pager.page - 1) + 1"></el-table-column>
      <el-table-column prop="Name" label="站点名称"></el-table-column>
      <el-table-column prop="StationType.Name" label="站点类型"></el-table-column>
      <el-table-column label="所属地区">
        <template slot-scope="scope">
          <span v-if="scope.row.Province">{{scope.row.Province.Name}}</span>
          <span v-if="scope.row.City">/{{scope.row.City.Name}}</span>
          <span v-if="scope.row.County">/{{scope.row.County.Name}}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" :reserve-selection="true"></el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      props: {
        value: 'CodeID',
        label: 'Name',
        children: 'Children',
        checkStrictly: true,
      },
      form: {
        BusinessTypeID: '',
        StationTypeID: '',
        ProvinceCodeID: '',
        CityCodeID: '',
        CountyCodeID: '',
      },
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      area: [0, 0, 0],
      options: [],
      rowData: {},
      itemList: [],
      loading: false,
      submitting: false,
      multipleSelection: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    getRowKey(row) {
      return row.ID;
    },
    onOpen() {
      this.rowData = _.clone(this.value);
      this.pager.page = 1;// 从第一页开始
      this.form.BusinessTypeID = this.value.BusinessTypeID;
      this.getItemList();
      this.choseArea();
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      // 清空选中项
      this.$refs.tb.clearSelection();
      this.multipleSelection = [];
    },
    onSubmitQuery() {
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get('station', {
          params: {
            where: this.form,
            with: [
              'BusinessType',
              'Platforms',
              'StationType',
              'Province',
              'City',
              'County',
            ],
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, 'size', 'page', 'total');
        }).then(() => {
          this.itemList.forEach((item) => {
            this.rowData.Stations.forEach((station) => {
              if (item.ID === station.ID) this.$refs.tb.toggleRowSelection(item, true);
            });
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSelectionChange(list) {
      this.multipleSelection = list.map(x => x.ID);
    },
    onSubmit() {
      this.submitting = true;
      if (this.area[0]) this.form.ProvinceCodeID = this.area[0];
      else this.form.ProvinceCodeID = '';
      if (this.area[1]) this.form.CityCodeID = this.area[1];
      else this.form.CityCodeID = '';
      if (this.area[2]) this.form.CountyCodeID = this.area[2];
      else this.form.CountyCodeID = '';
      this.$axios
        .request({
          url: `platform/${this.rowData.ID}/station`,
          method: 'post',
          data: { SIDS: this.multipleSelection },
        })
        .then(() => {
          this.$message.success('绑定成功');
          this.submitting = false;
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit('form:saved', false);
        });
    },
    choseArea() {
      this.$axios
        .get('area')
        .then((response) => {
          this.options = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
        });
    },
  },
};
</script>
